import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Menu } from 'antd'
import { app, use } from 'xadmin'
import { useMenuItems } from './hooks'

function flattenMenus(items, result = []) {
  items.forEach(item => {
      const {children, ...itemNoChildren} = item;
      result.push(itemNoChildren);
      if (children && children.length) {
        flattenMenus(children, result);
      }
  });
  return result;
}
const MainMenu = (props) => {
  const { canClick = true } = props
  const menuItems = app.get('menuItems')
  const { user } = use('auth.user')
  const { items, renderMenu } = useMenuItems(menuItems, canClick, user, 'MainMenu')

  const [selectedKeys, setSelectedKeys] = useState([]);
  // useEffect(() => {
  //   const storedSelectedKeys = localStorage.getItem('selectedKeys');
  //   if (storedSelectedKeys) {
  //     setSelectedKeys(JSON.parse(storedSelectedKeys));
  //   }
  // }, []);

  // const handleSelect = ({ key }) => {
  //   setSelectedKeys([key]);
  //   localStorage.setItem('selectedKeys', JSON.stringify([key]));
  // };
  const hash = window.location.hash.slice(1)
  const allMenuItems = flattenMenus(menuItems)
  useEffect(() => {
    const storedSelectedKeys = localStorage.getItem('selectedKeys');
    if (storedSelectedKeys) {
      setSelectedKeys(JSON.parse(storedSelectedKeys));
    }

    const foundKey = allMenuItems?.find((key) => {
      const menuItemPath = key?.url;
      return hash?.indexOf(menuItemPath) !== -1;
    });
    if (foundKey) {
      setSelectedKeys(foundKey?.url);
      localStorage.setItem('selectedKeys', JSON.stringify([foundKey?.url]));
    }
  }, [hash]);

  const handleSelect = ({ url }) => {
    setSelectedKeys([url]);
    localStorage.setItem('selectedKeys', JSON.stringify([url]));
  };

  return (
    <Menu
      mode={props.mode}
      theme={props.theme}
      // onClick={onMenuClick}
      inlineCollapsed={props.collapsed}
      style={{ overflowY: 'scroll', overflowY: 'overlay', minHeight: 100 }}
      selectedKeys={selectedKeys}
      onSelect={handleSelect}
    >
      {renderMenu(items, props?.mode)}
    </Menu >
  )
} 

export default MainMenu
